exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.footer[data-v-f906bf10] {\r\n  height: 102px;\r\n  background: #eeeeee;\r\n  color: #666666;\r\n  text-align: center;\r\n  font-size: 12px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f906bf10","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FooterBar.vue
// module id = zgzA
// module chunks = 129